/**
 * Where the map's bottom sheet rests: `peek` shows its title and the start of its content, `card` a
 * whole place card, and `home` the map home's greeting with its Start (and the 红包 above it). The
 * learner can also drag it up to the toolbar, or down until only its handle row (and the wallet in
 * its corners) is left above the bottom tabs.
 */
export type ChinaMapSheetDetent = "card" | "home" | "peek";

/** The sheet's resting heights above the bottom of the map, handle included. */
export const CHINA_MAP_SHEET_HEIGHTS: Record<ChinaMapSheetDetent, number> = {
  card: 300,
  home: 340,
  peek: 216,
};

/** Between the buttons riding the sheet, and between the lowest of them and the sheet. */
export const CHINA_MAP_SHEET_BUTTONS_GAP = 12;
